import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import portalHistory from './utils/portalHistory';
import { persistor, store } from './redux/store';
import {
  initializeServiceWorker,
  updateServiceWorker,
} from './redux/service-workers/actions';

import * as serviceWorker from './serviceWorker';

const Loading = () => <div>Loading...</div>;
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={portalHistory}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <App />
        </PersistGate>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onSuccess: () => store.dispatch(initializeServiceWorker()),
  onUpdate: (registration) => store.dispatch(updateServiceWorker(registration)),
});
